import React, { Component, Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import {
    validateProcessECO, validateProcessEstres, validateProcessPrueba, validateProcessEKG,
    validateProcessHolter, validateProcessMapa
} from '../../../../../Utils/UtilOtherProcedures';
import ResultProcedures from './ResultProcedures';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';

class Results extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eco: [],
            name_procedure: '',
            conclusiones_result: '',
            ekg: [],
            holter: [],
            map: [],
            stress: [],
            test: [],
            admissions: [],
            proceduresApplied: [], // Historial de Procedimientos del paciente
            expanded: false
        }
    }

    componentDidMount() {
        this.setState({
            eco: this.props.medicalProcedures.ECO,
            ekg: this.props.medicalProcedures.EKG,
            holter: this.props.medicalProcedures.Holter,
            map: this.props.medicalProcedures.Map,
            stress: this.props.medicalProcedures.stress,
            test: this.props.medicalProcedures.test,
        });

        console.log("RESULTADOS_OTROS", this.props.medicalProcedures);
        this.getClinicHistory();
        /* if(this.state.admissions.length === 0 ){
            let res = await this.checkingProcedures(this.state.admissions);
            console.log("RESSSISISISI",res)
        } */
    }

    componentDidUpdate(prevProps) {
        if (prevProps.shouldResultsBeUpdated !== this.props.shouldResultsBeUpdated) {
            this.getClinicHistory();
            //this.handlerSHouldResultBeUpdated();
        }
    }

    getClinicHistory = async () => {

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'evento/consultar/historia_clinica/' + this.props.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("ADMIsSIons", data);
                this.setState({ admissions: data.admisiones,/*  proceduresApplied: this.checkingProcedures(data.admisiones) */ }, () => this.checkingProcedures(this.state.admissions));
                //const result = await  this.checkingProcedures(data.admisiones);
                //console.log("WTY", result );
            })
            .catch((error) => {
                alert(error);
                console.error('Error:', error);
            });
    }

    handleChange = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    checkingProcedures = async (admissions) => {
        let wholeProcedures = [];
        for (let i = 0; i < admissions.length; i++) {
            if (admissions[i].hasOwnProperty("anamnesis")) {
                if (admissions[i].hasOwnProperty("procedimientos")) {
                    let resultsPocedures = [];
                    let procedureDate = admissions[i].fecha !== undefined && admissions[i].fecha !== null ? admissions[i].fecha : '';
                    if (admissions[i].procedimientos.eco.hasOwnProperty('eco') ||
                        admissions[i].procedimientos.estres.hasOwnProperty('estres') ||
                        admissions[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                        admissions[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                        admissions[i].procedimientos.holter.hasOwnProperty('holter') ||
                        admissions[i].procedimientos.mapa.hasOwnProperty('mapa')) {
                        let resultOtherProcedureEco = await validateProcessECO(admissions[i].procedimientos.eco.eco[0]) ? admissions[i].procedimientos.eco.eco[0].conclusiones : null;
                        let resultOtherProcedureEstres = await validateProcessEstres(admissions[i].procedimientos.estres.estres[0]) ? admissions[i].procedimientos.estres.estres[0].conclusiones : null;
                        let resultOtherProcedurePrueba = await validateProcessPrueba(admissions[i].procedimientos.prueba.prueba[0]) ? admissions[i].procedimientos.prueba.prueba[0].conclusiones : null;
                        let resultOtherProcedureEkg = await validateProcessEKG(admissions[i].procedimientos.ekg.ekg[0]) ?
                            admissions[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                                admissions[i].procedimientos.ekg.ekg[0].conclusions !== null ? admissions[i].procedimientos.ekg.ekg[0].conclusions :
                                admissions[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                    admissions[i].procedimientos.ekg.ekg[0].conclusion !== null ? admissions[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                        let resultOtherProcedureHolter = await validateProcessHolter(admissions[i].procedimientos.holter.holter[0]) ? admissions[i].procedimientos.holter.holter[0].conclusion : null;
                        let resultOtherProcedureMapa = await validateProcessMapa(admissions[i].procedimientos.mapa.mapa[0]) ? admissions[i].procedimientos.mapa.mapa[0].conclusion : null;

                        if (resultOtherProcedureEco !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEco, ['type']: 'ECO', ['id_servicio']: admissions[i].procedimientos.eco.eco[0].id_servicio });
                            }
                        }
                        if (resultOtherProcedureEstres !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEstres, ['type']: 'STRESS', ['id_servicio']: admissions[i].procedimientos.estres.estres[0].id_servicio });
                            }
                        }
                        if (resultOtherProcedurePrueba !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedurePrueba, ['type']: 'TEST', ['id_servicio']: admissions[i].procedimientos.prueba.prueba[0].id_servicio });
                            }
                        }
                        if (resultOtherProcedureEkg !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureEkg, ['type']: 'EKG', ['id_servicio']: admissions[i].procedimientos.ekg.ekg[0].id_servicio });
                            }
                        }
                        if (resultOtherProcedureHolter !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureHolter, ['type']: 'HOLTER', ['id_servicio']: admissions[i].procedimientos.holter.holter[0].id_servicio });
                            }
                        }
                        if (resultOtherProcedureMapa !== null) {
                            let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                            if (nameServ.length) {
                                resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: resultOtherProcedureMapa, ['type']: 'MAPA', ['id_servicio']: admissions[i].procedimientos.mapa.mapa[0].id_servicio });
                            }
                        }
                        console.log("MASDE1PROCEDIMIENTO", resultsPocedures)
                    }

                    if (!!resultsPocedures.length) {
                        try {
                            for (let k = 0; k < resultsPocedures.length; k++) {
                                const search = '\n';
                                const replaceWith = '<br />';
                                const result = resultsPocedures[k].result_procedure.split(search).join(replaceWith);
                                const attachFiles = admissions[i].archivos_procedimientos.find((fileProc) => fileProc.id_servicio === parseInt(resultsPocedures[k].id_servicio));
                                const urlFileAttached = !!attachFiles ? process.env.REACT_APP_PUBLIC_URL + attachFiles.url_adjunto + sessionStorage.getItem('token') : '';
                                wholeProcedures.push({ ['id_admision']: admissions[i].id_admision, ['name_procedure']: resultsPocedures[k].service_name, ['code_cups']: resultsPocedures[k].code_cups, ['conclution_result']: result, ['procedure_date']: procedureDate, ['type']: resultsPocedures[k].type, ['url_file']: urlFileAttached });
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                }
            } else if (admissions[i].hasOwnProperty("procedimientos")) {
                let resultsPocedures = [];
                let procedureDate = admissions[i].fecha !== undefined && admissions[i].fecha !== null ? admissions[i].fecha : '';
                if (admissions[i].procedimientos.eco.hasOwnProperty('eco') ||
                    admissions[i].procedimientos.estres.hasOwnProperty('estres') ||
                    admissions[i].procedimientos.prueba.hasOwnProperty('prueba') ||
                    admissions[i].procedimientos.ekg.hasOwnProperty('ekg') ||
                    admissions[i].procedimientos.holter.hasOwnProperty('holter') ||
                    admissions[i].procedimientos.mapa.hasOwnProperty('mapa')) {
                    let resultOtherProcedureEco = await validateProcessECO(admissions[i].procedimientos.eco.eco[0]) ? admissions[i].procedimientos.eco.eco[0].conclusiones : null;
                    let resultOtherProcedureEstres = await validateProcessEstres(admissions[i].procedimientos.estres.estres[0]) ? admissions[i].procedimientos.estres.estres[0].conclusiones : null;
                    let resultOtherProcedurePrueba = await validateProcessPrueba(admissions[i].procedimientos.prueba.prueba[0]) ? admissions[i].procedimientos.prueba.prueba[0].conclusiones : null;
                    let resultOtherProcedureEkg = await validateProcessEKG(admissions[i].procedimientos.ekg.ekg[0]) ?
                        admissions[i].procedimientos.ekg.ekg[0].conclusions !== undefined &&
                            admissions[i].procedimientos.ekg.ekg[0].conclusions !== null ? admissions[i].procedimientos.ekg.ekg[0].conclusions :
                            admissions[i].procedimientos.ekg.ekg[0].conclusion !== undefined &&
                                admissions[i].procedimientos.ekg.ekg[0].conclusion !== null ? admissions[i].procedimientos.ekg.ekg[0].conclusion : null : null;
                    let resultOtherProcedureHolter = await validateProcessHolter(admissions[i].procedimientos.holter.holter[0]) ? admissions[i].procedimientos.holter.holter[0].conclusion : null;
                    let resultOtherProcedureMapa = await validateProcessMapa(admissions[i].procedimientos.mapa.mapa[0]) ? admissions[i].procedimientos.mapa.mapa[0].conclusion : null;

                    let filesByThisAdmission = !!admissions[i].archivos_procedimientos.length ? admissions[i].archivos_procedimientos : [];

                    if (resultOtherProcedureEco !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.eco.eco[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '1');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedureEco ? resultOtherProcedureEco : "", ['type']: 'ECO', ['id_servicio']: admissions[i].procedimientos.eco.eco[0].id_servicio });
                        }
                    }
                    if (resultOtherProcedureEstres !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.estres.estres[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '3');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedureEstres ? resultOtherProcedureEstres : "", ['type']: 'STRESS', ['id_servicio']: admissions[i].procedimientos.estres.estres[0].id_servicio });
                        }
                    }
                    if (resultOtherProcedurePrueba !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.prueba.prueba[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '4');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedurePrueba ? resultOtherProcedurePrueba : "", ['type']: 'TEST', ['id_servicio']: admissions[i].procedimientos.prueba.prueba[0].id_servicio });
                        }
                    }
                    if (resultOtherProcedureEkg !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.ekg.ekg[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '2');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedureEkg ? resultOtherProcedureEkg : "", ['type']: 'EKG', ['id_servicio']: admissions[i].procedimientos.ekg.ekg[0].id_servicio });
                        }
                    }
                    if (resultOtherProcedureHolter !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.holter.holter[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '6');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedureHolter ? resultOtherProcedureHolter : "", ['type']: 'HOLTER', ['id_servicio']: admissions[i].procedimientos.holter.holter[0].id_servicio });
                        }
                    }
                    if (resultOtherProcedureMapa !== null || !!filesByThisAdmission.length) {
                        let isThereAnUploadedFile = filesByThisAdmission.find(file => file.id_servicio === admissions[i].procedimientos.mapa.mapa[0].id_servicio);
                        let nameServ = admissions[i].cita.servicio.servicios.filter((serv) => serv.formato === '7');
                        if (!!nameServ.length || !!isThereAnUploadedFile) {
                            resultsPocedures.push({ ['service_name']: nameServ[0].nombre, ['code_cups']: nameServ[0].codigo, ['result_procedure']: !!resultOtherProcedureMapa ? resultOtherProcedureMapa : "", ['type']: 'MAPA', ['id_servicio']: admissions[i].procedimientos.mapa.mapa[0].id_servicio });
                        }
                    }
                    console.log("MASDE1PROCEDIMIENTO", resultsPocedures)
                }

                if (!!resultsPocedures.length) {
                    try {
                        for (let k = 0; k < resultsPocedures.length; k++) {
                            const search = '\n';
                            const replaceWith = '<br />';
                            const result = resultsPocedures[k].result_procedure.split(search).join(replaceWith);
                            const attachFiles = admissions[i].archivos_procedimientos.find((fileProc) => fileProc.id_servicio === parseInt(resultsPocedures[k].id_servicio));
                            const urlFileAttached = !!attachFiles ? process.env.REACT_APP_PUBLIC_URL + attachFiles.url_adjunto + sessionStorage.getItem('token') : '';
                            wholeProcedures.push({ ['id_admision']: admissions[i].id_admision, ['name_procedure']: resultsPocedures[k].service_name, ['code_cups']: resultsPocedures[k].code_cups, ['conclution_result']: result, ['procedure_date']: procedureDate, ['type']: resultsPocedures[k].type, ['url_file']: urlFileAttached })
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else if (!!admissions[i].archivos_procedimientos.length) {
                    wholeProcedures.push({ ['id_admision']: admissions[i].id_admision, ['name_procedure']: nameService, ['code_cups']: cupsCod, ['conclution_result']: admissions[i].transcripcion.transcripcion, ['procedure_date']: admissions[i].fecha, ['type']: 'gamagrafia', ['id_transcripcion']: admissions[i].transcripcion.id_transcripcion })
                }

            } else if (admissions[i].transcripcion !== null && admissions[i].transcripcion !== undefined) {
                let nameService = admissions[i].cita.hasOwnProperty('servicio') ? admissions[i].cita.servicio !== null && admissions[i].cita.servicio !== undefined ? admissions[i].cita.servicio.servicios.length > 0 ? admissions[i].cita.servicio.servicios[0].cupscod + " " + admissions[i].cita.servicio.servicios[0].nombre : '' : '' : '';
                let cupsCod = admissions[i].cita.hasOwnProperty('servicio') ? admissions[i].cita.servicio !== null && admissions[i].cita.servicio !== undefined ? admissions[i].cita.servicio.servicios.length > 0 ? admissions[i].cita.servicio.servicios[0].cupscod : '' : '' : '';
                wholeProcedures.push({ ['id_admision']: admissions[i].id_admision, ['name_procedure']: nameService, ['code_cups']: cupsCod, ['conclution_result']: admissions[i].transcripcion.transcripcion, ['procedure_date']: admissions[i].fecha, ['type']: 'gamagrafia', ['id_transcripcion']: admissions[i].transcripcion.id_transcripcion })

            }
            this.setState({ proceduresApplied: wholeProcedures });
            //return wholeProcedures;
        }

    }

    render() {

        return (
            <Fragment>
                <Col md={12} sm={12}>
                    <div className={"container-wraper-hc"}>
                        <div className="title-clinic-history">
                            <h4>Resultados Institucionales</h4>
                        </div>
                        <div className="form" style={{ display: 'flex', flexDirection: 'column', marginTop: '1em' }}>
                            {this.state.proceduresApplied.length !== 0 ?
                                this.state.proceduresApplied.map((procedure, index) =>
                                    <Accordion key={index} expanded={this.state.expanded === `panel${index}`} onChange={this.handleChange(`panel${index}`)}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            //onClick={() => searchEventFromClinicHistoryComplete(evento_c.id_admision)}
                                            aria-controls={`panel${index}-content`}
                                            id={`panel${index}-header`}
                                        >
                                            <Col md={6}>
                                                <h5>{procedure.code_cups}<b> {procedure.name_procedure}</b></h5>
                                            </Col>
                                            <Col md={6}>
                                                <h5>Fecha del Procedimiento: {moment(procedure.procedure_date).format('DD-MM-YYYY')}</h5>
                                            </Col>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <ResultProcedures key={index} procedure={procedure} />
                                        </AccordionDetails>
                                    </Accordion>
                                )
                                :
                                <div>
                                    <p>El paciente aún no tiene resultados de procedimientos</p>
                                </div>}
                        </div>
                    </div>
                </Col>
            </Fragment>
        );
    }
}

export default Results;